<div class="flex w-full h-full p-6 gap-6 bg-surface-50 flex-col">
  <p-card>
    <div class="flex flex-col gap-4">

      <div class="flex gap-2 items-center flex-wrap">
        <span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Time Range</span>
        <p-button label="Last hour" size="small" severity="secondary" [outlined]="activePreset() !== 'hour'"
                  data-testid="auditlog-preset-hour" (onClick)="applyPreset('hour')" />
        <p-button label="Today" size="small" severity="secondary" [outlined]="activePreset() !== 'today'"
                  data-testid="auditlog-preset-today" (onClick)="applyPreset('today')" />
        <p-button label="Last 7 days" size="small" severity="secondary" [outlined]="activePreset() !== 'week'"
                  data-testid="auditlog-preset-week" (onClick)="applyPreset('week')" />
        <p-button label="Last 30 days" size="small" severity="secondary" [outlined]="activePreset() !== 'month'"
                  data-testid="auditlog-preset-month" (onClick)="applyPreset('month')" />
      </div>

      <div class="flex gap-4 flex-wrap">
        <div class="flex-col gap-2">
          <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">From Date</span></div>
          <p-datepicker [(ngModel)]="filters.dateFrom"
                        (ngModelChange)="onCustomRangeChange()"
                        [iconDisplay]="'input'"
                        [showIcon]="true"
                        [dateFormat]="'dd/mm/y'"
                        placeholder="DD/MM/YY"
                        size="small"
                        appendTo="body"
                        [maxDate]="filters.dateTo"
                        showClear
          ></p-datepicker>
        </div>

        <div class="flex-col gap-2">
          <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">To Date</span></div>
          <p-datepicker [(ngModel)]="filters.dateTo"
                        (ngModelChange)="onCustomRangeChange()"
                        [iconDisplay]="'input'"
                        [showIcon]="true"
                        [dateFormat]="'dd/mm/y'"
                        placeholder="DD/MM/YY"
                        size="small"
                        appendTo="body"
                        [minDate]="filters.dateFrom"
                        showClear
          ></p-datepicker>
        </div>
      </div>

      <div class="flex gap-4 flex-wrap">
        <div class="flex-col gap-2 flex-1">
          <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">User</span></div>
          <p-multiSelect [options]="availableUsers()"
                         optionLabel="name"
                         placeholder="All users"
                         class="w-full"
                         size="small"
                         [(ngModel)]="filters.users"
                         showClear
                         [filter]="true"
                         filterPlaceHolder="Search users..."
                         [virtualScroll]="true"
                         [virtualScrollItemSize]="40"
          >
            <ng-template let-user #item>
              <span title="{{user.email}}">{{ user.name }}</span>
            </ng-template>
          </p-multiSelect>
        </div>

        <div class="flex-col gap-2 flex-1">
          <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Level</span></div>
          <p-multiSelect [options]="levelOptions"
                         placeholder="All levels (System / Admin / User)"
                         class="w-full"
                         size="small"
                         [(ngModel)]="filters.levels"
                         showClear
          ></p-multiSelect>
        </div>

        <div class="flex-col gap-2 flex-1">
          <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Event Type</span></div>
          <p-multiSelect [options]="eventTypeOptions"
                         placeholder="All event types"
                         class="w-full"
                         size="small"
                         [(ngModel)]="filters.eventTypes"
                         showClear
                         [filter]="true"
                         filterPlaceHolder="Search event types..."
          ></p-multiSelect>
        </div>
      </div>

      <div class="flex justify-end gap-2">
        <p-button label="Search" severity="primary" icon="fa fa-magnifying-glass"
                  data-testid="auditlog-search" (onClick)="runSearch()"></p-button>
        <p-button label="Clear" severity="secondary" icon="fa fa-x" (onClick)="clearSearch()"></p-button>
      </div>

    </div>
  </p-card>

  <div class="flex flex-col gap-2 flex-1 min-h-0">

    <div class="flex gap-2 items-center">
      <input type="text"
             pInputText
             [(ngModel)]="filterInput"
             class="w-1/3"
             pSize="small"
             placeholder="Filter loaded events by user or details..."
             data-testid="auditlog-filter"
      />
      <div class="bg-white rounded">
        <p-button label="Clear" size="small" severity="secondary" outlined
                  icon="fa fa-x" (onClick)="clearFilter()" />
      </div>
      <div class="flex-1"></div>
    </div>

    @if (hasSearched() && auditLogList().length > 0) {
      <div class="text-xs text-slate-500">
        @if (hasFilter()) {
          Showing {{rows().length}} of {{auditLogList().length}} loaded events ({{totalCount()}} match the search)
        } @else {
          Showing {{auditLogList().length}} of {{totalCount()}} events
        }
      </div>
      @if (hasFilter() && canLoadMore()) {
        <div class="text-xs text-slate-500 italic">
          The text filter only searches the events loaded so far &mdash; load more to widen it.
        </div>
      }
    }

    @if (!hasSearched()) {
      <div class="px-2 pt-4 text-slate-500 text-sm font-normal font-['Inter'] leading-6"
           data-testid="auditlog-empty-initial">
        Choose a time range and press Search to look through the audit log.
      </div>
    } @else if (!auditLogList().length) {
      <div class="px-2 pt-4 text-slate-500 text-sm font-normal font-['Inter'] leading-6"
           data-testid="auditlog-empty-nosearchresults"><i>No audit events in this time range</i></div>
    } @else if (!rows().length) {
      <div class="px-2 pt-4 flex flex-col gap-3 items-start" data-testid="auditlog-empty-nofilterresults">
        <div class="text-slate-500 text-sm font-normal font-['Inter'] leading-6">
          <i>None of the {{auditLogList().length}} loaded events match "{{filterStr()}}"</i>
        </div>
        <div class="flex gap-2">
          <p-button label="Clear filter" size="small" severity="secondary" outlined
                    icon="fa fa-x" (onClick)="clearFilter()" />
          @if (canLoadMore()) {
            <p-button label="Load More" size="small" severity="secondary"
                      icon="fa fa-arrow-down" [disabled]="isLoading()" (onClick)="loadMore()" />
          }
        </div>
      </div>
    } @else {
      <div #scrollContainer scrollHeight [bottomPadding]="80"
           class="rounded-lg border-[1px] border-surface-300 overflow-y-auto bg-white">
        <p-table [value]="rows()" stripedRows [tableStyle]="{'min-width': '60rem'}"
                 data-testid="auditlog-table">
          <ng-template #header>
            <tr>
              <th>Date/Time</th>
              <th>User</th>
              <th>Level</th>
              <th>Event</th>
              <th>Details</th>
            </tr>
          </ng-template>

          <ng-template #body let-row>
            <tr>
              <td class="align-top whitespace-nowrap"
                  [title]="row.event.eventDate | date:'medium'">{{row.event.eventDate | date:'dd/MM/yy HH:mm:ss'}}</td>

              <td class="align-top">
                <div class="flex flex-col">
                  @if (row.nameSegments.length) {
                    <span>
                      @for (seg of row.nameSegments; track $index) {
                        @if (seg.matched) {
                          <mark class="bg-yellow-200 text-inherit">{{seg.text}}</mark>
                        } @else {
                          <span>{{seg.text}}</span>
                        }
                      }
                    </span>
                  }
                  <span class="text-xs text-surface-500">
                    @for (seg of row.emailSegments; track $index) {
                      @if (seg.matched) {
                        <mark class="bg-yellow-200 text-inherit">{{seg.text}}</mark>
                      } @else {
                        <span>{{seg.text}}</span>
                      }
                    }
                  </span>
                </div>
              </td>

              <td class="align-top">{{row.event.level ?? '-'}}</td>
              <td class="align-top">{{row.event.eventType ?? '-'}}</td>

              <td class="align-top">
                <div class="flex flex-col gap-0.5">
                  @for (cell of row.meta; track $index) {
                    <div class="flex gap-2 text-xs">
                      <span class="text-surface-500">
                        @for (seg of cell.labelSegments; track $index) {
                          @if (seg.matched) {
                            <mark class="bg-yellow-200 text-inherit">{{seg.text}}</mark>
                          } @else {
                            <span>{{seg.text}}</span>
                          }
                        }:
                      </span>
                      @if (cell.link) {
                        <a [routerLink]="cell.link" target="_blank" class="text-primary hover:underline">
                          @for (seg of cell.valueSegments; track $index) {
                            @if (seg.matched) {
                              <mark class="bg-yellow-200 text-inherit">{{seg.text}}</mark>
                            } @else {
                              <span>{{seg.text}}</span>
                            }
                          }
                        </a>
                      } @else {
                        <span>
                          @for (seg of cell.valueSegments; track $index) {
                            @if (seg.matched) {
                              <mark class="bg-yellow-200 text-inherit">{{seg.text}}</mark>
                            } @else {
                              <span>{{seg.text}}</span>
                            }
                          }
                        </span>
                      }
                    </div>
                  } @empty {
                    <span class="text-surface-500 italic">-</span>
                  }
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        @if (canLoadMore()) {
          <div #loadMoreSentinel class="flex items-center justify-center gap-3 py-3">
            <p-button label="Load More"
                      severity="secondary"
                      size="small"
                      icon="fa fa-arrow-down"
                      [disabled]="isLoading()"
                      (onClick)="loadMore()">
            </p-button>
          </div>
        }
      </div>
    }

  </div>
</div>
